import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmRemoveModalProps {
  isOpen: boolean;
  trackName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const ConfirmRemoveModal = memo(
  ({
    isOpen,
    trackName,
    onConfirm,
    onCancel,
    isLoading = false,
  }: ConfirmRemoveModalProps) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
        <div className="bg-black/90 backdrop-blur-md border border-white/20 rounded-2xl shadow-2xl w-full max-w-sm">
          {/* Header */}
          <div className="p-6 border-b border-white/10">
            <h2 className="text-xl font-semibold text-white">
              {t('player.removeFromPlaylistTitle')}
            </h2>
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-white/80 mb-2">
              {t('player.removeConfirmation', { name: trackName })}
            </p>
          </div>

          {/* Footer - Buttons */}
          <div className="p-6 border-t border-white/10 flex gap-3 justify-end">
            <button
              onClick={onCancel}
              disabled={isLoading}
              className="px-4 h-[44px] bg-[rgba(128,128,128,0.3)] hover:bg-[rgba(128,128,128,0.4)] border-t border-[rgba(255,255,255,0.5)] text-white rounded-[16px] font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center">
              {t('common.cancel')}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="px-4 h-[44px] bg-red-600 hover:bg-red-700 text-white rounded-[16px] font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 justify-center">
              {isLoading && (
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              )}
              {t('account.remove')}
            </button>
          </div>
        </div>
      </div>
    );
  },
);

ConfirmRemoveModal.displayName = 'ConfirmRemoveModal';
